(function() {
  var root = document.querySelector('[data-nc-collection]');
  if (!root) return;
  if (root.dataset.ncCollectionInit === '1') return;
  root.dataset.ncCollectionInit = '1';

  var cards       = Array.prototype.slice.call(root.querySelectorAll('[data-nc-card]'));
  var grid        = root.querySelector('[data-nc-grid]');
  var countValue  = root.querySelector('[data-nc-count-value]');
  var emptyEl     = root.querySelector('[data-nc-empty]');
  var loadWrap    = root.querySelector('[data-nc-load-more-wrap]');
  var loadBtn     = root.querySelector('[data-nc-load-more]');
  var sortSel     = root.querySelector('[data-nc-sort]');
  var searchInput = root.querySelector('[data-nc-collection-search]');
  var panelEl     = root.querySelector('[data-nc-filter-panel]');
  var overlayEl   = root.querySelector('[data-nc-filter-overlay]');
  var openBtn     = root.querySelector('[data-nc-filter-open]');
  var closeBtn    = root.querySelector('[data-nc-filter-close]');
  var releaseFilterTrap = null;
  var dropdowns   = Array.prototype.slice.call(root.querySelectorAll('[data-nc-dropdown]'));
  var checkboxes  = Array.prototype.slice.call(root.querySelectorAll('[data-nc-filter-checkbox]'));
  var etatValues  = checkboxes.reduce(function(values, cb) {
    var value = cb.dataset.filterKey === 'etat' && cb.dataset.filterValue;
    if (value && values.indexOf(value) === -1) values.push(value);
    return values;
  }, []);
  var resetBtns   = Array.prototype.slice.call(root.querySelectorAll('[data-nc-reset]'));
  var chipsEl     = root.querySelector('[data-nc-active-filters]');
  var clearBtn    = root.querySelector('.nc-coll-main__clear');
  var searchTimer = null;

  var pageSize = parseInt(root.dataset.pageSize, 10) || 24;
  var ranges   = ['surface', 'volume', 'longueur'];
  var rangeBounds = {};
  ranges.forEach(function(k) {
    rangeBounds[k] = {
      min: parseFloat(root.dataset[k + 'Min']) || 0,
      max: parseFloat(root.dataset[k + 'Max']) || 0
    };
  });

  var state = {
    etat: [],
    materiaux: [],
    taille: [],
    sousfamille: [],
    surface: [null, null],
    volume: [null, null],
    longueur: [null, null],
    search: '',
    sort: 'manual',
    page: 1
  };

  function parseURL() {
    var params = new URLSearchParams(window.location.search);
    ['etat', 'materiaux', 'taille', 'sousfamille'].forEach(function(k) {
      var v = params.get(k);
      if (v) state[k] = v.split(',').filter(Boolean);
    });
    ranges.forEach(function(k) {
      var v = params.get(k);
      if (!v) return;
      var parts = v.split('-').map(parseFloat);
      if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
        state[k] = [parts[0], parts[1]];
      }
    });
    var s = params.get('sort');
    if (s) state.sort = s;
    state.search = (params.get('recherche') || '').trim();
  }

  function syncURL() {
    var url = new URL(window.location.href);
    var params = url.searchParams;
    ['etat', 'materiaux', 'taille', 'sousfamille', 'surface', 'volume', 'longueur', 'sort', 'recherche'].forEach(function(k) {
      params.delete(k);
    });
    ['etat', 'materiaux', 'taille', 'sousfamille'].forEach(function(k) {
      if (state[k].length) params.set(k, state[k].join(','));
    });
    ranges.forEach(function(k) {
      if (state[k][0] != null && state[k][1] != null) {
        params.set(k, state[k][0] + '-' + state[k][1]);
      }
    });
    if (state.sort && state.sort !== 'manual') params.set('sort', state.sort);
    if (state.search.trim()) params.set('recherche', state.search.trim());
    try { history.replaceState(null, '', url.pathname + url.search + url.hash); } catch (_) {}
  }

  function cardNum(card, key) {
    var v = parseFloat(card.dataset[key]);
    return isNaN(v) ? null : v;
  }

  function matchesExcept(card, skipKey) {
    if (state.search && normalizeText(cardTitle(card)).indexOf(normalizeText(state.search)) === -1) return false;
    if (skipKey !== 'etat' && state.etat.length && state.etat.indexOf(card.dataset.etat) === -1) return false;
    if (skipKey !== 'materiaux' && state.materiaux.length && state.materiaux.indexOf(card.dataset.materiaux) === -1) return false;
    if (skipKey !== 'taille' && state.taille.length && state.taille.indexOf(card.dataset.taille) === -1) return false;
    if (skipKey !== 'sousfamille' && state.sousfamille.length && state.sousfamille.indexOf(card.dataset.sousfamille) === -1) return false;
    for (var i = 0; i < ranges.length; i++) {
      var r = ranges[i];
      if (skipKey === r) continue;
      var rmin = state[r][0], rmax = state[r][1];
      if (rmin == null && rmax == null) continue;
      var v = cardNum(card, r);
      if (v == null) continue;
      if (rmin != null && v < rmin) return false;
      if (rmax != null && v > rmax) return false;
    }
    return true;
  }

  function matches(card) {
    return matchesExcept(card, null);
  }

  var tailleRank = { '20-pieds': 0, '40-pieds': 1, '45-pieds': 2, '10-pieds': 3 };

  // Ordre d'affichage des sous-familles : du plus standard au plus spécifique.
  // Critère primaire du tri par défaut ; chaque sous-famille reste groupée.
  var sousFamilleRank = {
    // Dry — standard
    'dry': 0, 'high-cube': 1, 'pallet-wide': 2,
    // Dry — accès / ouverture
    'double-porte': 3, 'open-side': 4, 'open-top': 5, 'hard-top': 6, 'tridoor': 7, '4-portes-laterales': 8,
    // Dry — plateau / hors-gabarit
    'flat-rack': 9, 'plateforme': 10, 'demi-hauteur': 11,
    // Dry — spéciaux / normés
    'bulk': 12, 'citerne': 13, 'dnv': 14, 'ip2': 15,
    // Froid — reefer standard, isotherme, puis variantes reefer
    'reefer': 16, 'isotherme': 17, 'reefer-hc': 18, 'reefer-dnv': 19, 'reefer-pallet-wide': 20, 'reefer-open-side': 21, 'reefer-4-moteurs': 22, 'reefer-super-freezer': 23,
    // Aménagé
    'amenage': 24, 'amenage-bureau': 25, 'amenage-sanitaire': 26, 'amenage-bungalow': 27
  };

  function cardTitle(card) {
    return ((card.querySelector('.nc-listing-card__title') || {}).textContent || '').trim();
  }

  function normalizeText(value) {
    return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  }

  function subfamilyKey(title) {
    return title.replace(/\b(10|20|40|45)\s*pieds?\b/gi, '').replace(/\s+/g, ' ').trim();
  }

  // Petits formats (5 à 9 pieds) : relégués en toute fin de liste.
  function estPetitFormat(card) {
    var m = cardTitle(card).match(/(\d+)\s*pieds?/i);
    return m != null && parseInt(m[1], 10) < 10;
  }

  function sortCards(cs) {
    var s = state.sort;
    var clone = cs.slice();
    clone.sort(function(a, b) {
      if (s === 'title-asc' || s === 'title-desc') {
        var ta = cardTitle(a), tb = cardTitle(b);
        return s === 'title-asc' ? ta.localeCompare(tb, 'fr') : tb.localeCompare(ta, 'fr');
      }
      if (s === 'surface-asc' || s === 'surface-desc') {
        var va = cardNum(a, 'surface') || 0;
        var vb = cardNum(b, 'surface') || 0;
        return s === 'surface-asc' ? va - vb : vb - va;
      }
      // Petits formats (5–9 pieds) toujours en dernier ; s'ils sont deux, la
      // logique sous-famille/taille/titre ci-dessous les ordonne entre eux.
      var pa = estPetitFormat(a), pb = estPetitFormat(b);
      if (pa !== pb) return pa ? 1 : -1;
      // Défaut : sous-famille (standard → spécifique), puis taille (20 → 40 → 45 → 10).
      var ra = sousFamilleRank[a.dataset.sousfamille]; if (ra == null) ra = 99;
      var rb = sousFamilleRank[b.dataset.sousfamille]; if (rb == null) rb = 99;
      if (ra !== rb) return ra - rb;
      var ar = tailleRank[a.dataset.taille]; if (ar == null) ar = 99;
      var br = tailleRank[b.dataset.taille]; if (br == null) br = 99;
      if (ar !== br) return ar - br;
      // Filet déterministe pour les sous-familles hors barème (rang 99).
      return subfamilyKey(cardTitle(a)).localeCompare(subfamilyKey(cardTitle(b)), 'fr');
    });
    return clone;
  }

  function bucketize(values, min, max, nb) {
    var counts = new Array(nb).fill(0);
    if (max <= min) return counts;
    var step = (max - min) / nb;
    values.forEach(function(v) {
      if (v == null || isNaN(v)) return;
      if (v < min || v > max) return;
      var idx = Math.floor((v - min) / step);
      if (idx >= nb) idx = nb - 1;
      counts[idx]++;
    });
    return counts;
  }

  function recomputeHistograms() {
    ranges.forEach(function(k) {
      var b = rangeBounds[k];
      if (b.max <= b.min) return;
      var rangeRoot = root.querySelector('[data-nc-range][data-param="' + k + '"]');
      if (!rangeRoot || !rangeRoot.ncRangeAPI) return;
      var values = [];
      cards.forEach(function(card) {
        if (!matchesExcept(card, k)) return;
        var v = cardNum(card, k);
        if (v != null) values.push(v);
      });
      var nb = rangeRoot.querySelectorAll('.nc-range__bar').length || 16;
      var counts = bucketize(values, b.min, b.max, nb);
      rangeRoot.ncRangeAPI.setBuckets(counts);
    });
  }

  function recomputeCheckboxCounts() {
    var countsByKey = { etat: {}, materiaux: {}, taille: {}, sousfamille: {} };
    cards.forEach(function(card) {
      ['etat', 'materiaux', 'taille', 'sousfamille'].forEach(function(k) {
        if (!matchesExcept(card, k)) return;
        var val = card.dataset[k];
        if (!val) return;
        countsByKey[k][val] = (countsByKey[k][val] || 0) + 1;
      });
    });
    checkboxes.forEach(function(cb) {
      var k = cb.dataset.filterKey;
      var v = cb.dataset.filterValue;
      var c = (countsByKey[k] && countsByKey[k][v]) || 0;
      var label = cb.closest('.nc-coll-main__option, .nc-coll-main__condition-option');
      var countEl = label && label.querySelector('[data-nc-count-for="' + k + ':' + v + '"]');
      if (countEl) countEl.textContent = '(' + c + ')';
      if (label) {
        var disabledClass = label.classList.contains('nc-coll-main__condition-option')
          ? 'nc-coll-main__condition-option--disabled'
          : 'nc-coll-main__option--disabled';
        if (c === 0 && !cb.checked) {
          label.classList.add(disabledClass);
          cb.disabled = true;
        } else {
          label.classList.remove(disabledClass);
          cb.disabled = false;
        }
      }
    });
  }

  function updateRangeDisplays() {
    ranges.forEach(function(k) {
      var display = root.querySelector('[data-filter-key="' + k + '"] [data-nc-range-display]');
      if (!display) return;
      var mn = state[k][0], mx = state[k][1];
      if (mn == null && mx == null) {
        display.textContent = '';
      } else {
        var unit = k === 'surface' ? 'm²' : (k === 'volume' ? 'm³' : 'm');
        display.textContent = mn + '–' + mx + ' ' + unit;
      }
    });
  }

  function rangeMeta(k) {
    if (k === 'surface') return { name: 'Surface', unit: 'm²' };
    if (k === 'volume') return { name: 'Volume', unit: 'm³' };
    return { name: 'Longueur', unit: 'm' };
  }

  function anyFilterActive() {
    if (state.search) return true;
    if (state.etat.length || state.materiaux.length || state.taille.length || state.sousfamille.length) return true;
    return ranges.some(function(k) { return state[k][0] != null && state[k][1] != null; });
  }

  function makeChip(key, type, value, label) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'nc-coll-main__chip';
    btn.dataset.chipKey = key;
    btn.dataset.chipType = type;
    if (value != null) btn.dataset.chipValue = value;
    btn.setAttribute('aria-label', 'Retirer le filtre : ' + label);
    var txt = document.createElement('span');
    txt.textContent = label;
    var x = document.createElement('span');
    x.className = 'nc-coll-main__chip-x';
    x.setAttribute('aria-hidden', 'true');
    x.textContent = '×';
    btn.appendChild(txt);
    btn.appendChild(x);
    return btn;
  }

  /* C.16 — chips de filtres actifs : récap visuel + suppression rapide */
  function renderChips() {
    if (!chipsEl) return;
    chipsEl.textContent = '';
    ['etat', 'materiaux', 'taille', 'sousfamille'].forEach(function(k) {
      state[k].forEach(function(v) {
        var cb = root.querySelector('[data-nc-filter-checkbox][data-filter-key="' + k + '"][data-filter-value="' + v + '"]');
        var label = v;
        if (cb) {
          var opt = cb.closest('.nc-coll-main__option');
          var sp = opt && opt.querySelector('span');
          if (sp) label = sp.textContent.trim();
        }
        chipsEl.appendChild(makeChip(k, 'list', v, label));
      });
    });
    ranges.forEach(function(k) {
      if (state[k][0] == null || state[k][1] == null) return;
      var m = rangeMeta(k);
      chipsEl.appendChild(makeChip(k, 'range', null, m.name + ' ' + state[k][0] + '–' + state[k][1] + ' ' + m.unit));
    });
    if (clearBtn) clearBtn.hidden = !anyFilterActive();
  }

  function apply() {
    syncCheckboxControls();
    var visibleCards = cards.filter(matches);
    var sorted = sortCards(visibleCards);
    var sortedSet = new Set(sorted);

    cards.forEach(function(card) {
      card.hidden = !sortedSet.has(card);
    });

    if (sorted.length) {
      sorted.forEach(function(card) { grid.appendChild(card); });
    }

    var limit = state.page * pageSize;
    sorted.forEach(function(card, i) {
      if (i >= limit) card.hidden = true;
    });

    var total = sorted.length;
    if (countValue) countValue.textContent = total;

    emptyEl.hidden = total > 0;
    loadWrap.hidden = total <= limit;

    recomputeHistograms();
    recomputeCheckboxCounts();
    updateRangeDisplays();
    renderChips();
    syncURL();
  }

  function syncCheckboxControls() {
    checkboxes.forEach(function(cb) {
      var k = cb.dataset.filterKey;
      var v = cb.dataset.filterValue;
      cb.checked = k === 'etat' && etatValues.length && !state.etat.length
        ? etatValues.indexOf(v) !== -1
        : state[k].indexOf(v) !== -1;
    });
  }

  function hydrateControls() {
    syncCheckboxControls();
    if (searchInput) searchInput.value = state.search;
    if (sortSel) sortSel.value = state.sort;
    ranges.forEach(function(k) {
      var rangeRoot = root.querySelector('[data-nc-range][data-param="' + k + '"]');
      if (rangeRoot && rangeRoot.ncRangeAPI) {
        rangeRoot.ncRangeAPI.setRange(state[k][0], state[k][1]);
      }
    });
  }

  function onCheckboxChange(e) {
    var cb = e.target;
    if (!cb.matches('[data-nc-filter-checkbox]')) return;
    var k = cb.dataset.filterKey;
    var v = cb.dataset.filterValue;

    if (k === 'etat' && etatValues.length) {
      var nextEtats = state.etat.length ? state.etat.slice() : etatValues.slice();
      var etatIdx = nextEtats.indexOf(v);

      if (cb.checked && etatIdx === -1) nextEtats.push(v);
      else if (!cb.checked && etatIdx !== -1) {
        if (nextEtats.length === 1) {
          syncCheckboxControls();
          return;
        }
        nextEtats.splice(etatIdx, 1);
      }

      state.etat = etatValues.every(function(value) {
        return nextEtats.indexOf(value) !== -1;
      }) ? [] : nextEtats;
    } else {
      var idx = state[k].indexOf(v);
      if (cb.checked && idx === -1) state[k].push(v);
      else if (!cb.checked && idx !== -1) state[k].splice(idx, 1);
    }
    state.page = 1;
    apply();
  }

  function onRangeChange(e) {
    var d = e.detail || {};
    if (ranges.indexOf(d.paramName) === -1) return;
    state[d.paramName] = [d.min, d.max];
    state.page = 1;
    apply();
  }

  function onSort() {
    state.sort = sortSel.value;
    state.page = 1;
    apply();
  }

  function onSearchInput() {
    state.search = searchInput.value.trim();
    state.page = 1;
    if (searchTimer) clearTimeout(searchTimer);
    searchTimer = setTimeout(function() {
      searchTimer = null;
      apply();
    }, 120);
  }

  function onReset() {
    state.etat = [];
    state.materiaux = [];
    state.taille = [];
    state.sousfamille = [];
    ranges.forEach(function(k) { state[k] = [null, null]; });
    state.search = '';
    state.sort = 'manual';
    state.page = 1;
    hydrateControls();
    apply();
  }

  function onLoadMore() {
    state.page++;
    apply();
  }

  function openPanel() {
    panelEl.setAttribute('data-open', 'true');
    panelEl.setAttribute('role', 'dialog');
    panelEl.setAttribute('aria-modal', 'true');
    panelEl.setAttribute('aria-labelledby', 'nc-filters-title');
    if (overlayEl) overlayEl.setAttribute('data-open', 'true');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    releaseFilterTrap = window.NCA11y && window.NCA11y.trapFocus(panelEl, { onEscape: closePanel });
    window.requestAnimationFrame(function() {
      if (closeBtn) closeBtn.focus();
    });
  }
  function closePanel() {
    if (releaseFilterTrap) releaseFilterTrap();
    releaseFilterTrap = null;
    panelEl.removeAttribute('data-open');
    panelEl.removeAttribute('role');
    panelEl.removeAttribute('aria-modal');
    panelEl.removeAttribute('aria-labelledby');
    if (overlayEl) overlayEl.removeAttribute('data-open');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    if (openBtn) openBtn.focus();
  }

  root.addEventListener('change', onCheckboxChange);
  root.addEventListener('nc:range:change', onRangeChange);
  if (sortSel) sortSel.addEventListener('change', onSort);
  if (searchInput) searchInput.addEventListener('input', onSearchInput);
  resetBtns.forEach(function(btn) { btn.addEventListener('click', onReset); });
  if (chipsEl) {
    chipsEl.addEventListener('click', function(e) {
      var chip = e.target.closest('.nc-coll-main__chip');
      if (!chip) return;
      var k = chip.dataset.chipKey;
      if (chip.dataset.chipType === 'range') {
        state[k] = [null, null];
      } else {
        var v = chip.dataset.chipValue;
        var idx = state[k].indexOf(v);
        if (idx !== -1) state[k].splice(idx, 1);
      }
      state.page = 1;
      hydrateControls();
      apply();
    });
  }
  if (loadBtn) loadBtn.addEventListener('click', onLoadMore);
  if (openBtn) openBtn.addEventListener('click', openPanel);
  if (closeBtn) closeBtn.addEventListener('click', closePanel);
  if (overlayEl) overlayEl.addEventListener('click', closePanel);

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    if (panelEl && panelEl.getAttribute('data-open') === 'true') closePanel();
    dropdowns.forEach(function(dd) {
      if (dd.open) {
        dd.open = false;
        var summary = dd.querySelector('summary');
        if (summary) summary.focus();
      }
    });
  });

  dropdowns.forEach(function(dd) {
    document.addEventListener('click', function(e) {
      if (!dd.open) return;
      if (dd.contains(e.target)) return;
      dd.open = false;
    });
  });

  function ready() {
    parseURL();
    hydrateControls();
    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    setTimeout(ready, 0);
  }
})();
